import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { connect } from 'react-redux';

import withResponsiveWrapper from '../../decorators/withResponsiveWrapper';
import { footerMessages as messages } from '../../defineMessages';
import List from '../List/List';
import Brand from '../Brand/Brand';
import CountrySwitcher from '../CountrySwitcher/CountrySwitcher';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import { setPath } from '../../actions/intl';

import s from './CatalogHeader.scss';

const CatalogHeader = ({ logo, countryCode, intl, dispatch }) => {
  const changeCountry = useCallback(
    countryValue => {
      dispatch(setPath({ country: countryValue }));
    },
    [dispatch],
  );
  return (
    <div className={s.sticky}>
      <div className={s.root}>
        {logo ? (
          <div className={s.brandWrapper}>
            <img src={logo} alt="Logo" />
          </div>
        ) : (
          <Brand className={s.brandWrapper} />
        )}

        <List container className={s.menuList}>
          <List item component="li">
            <LanguageSwitcher
              labelRootClass={s.lanLabel}
              selectRootClass={s.lanSelect}
              label={intl.formatMessage({ ...messages.language })}
              onChange={value => dispatch(setPath({ locale: value }))}
            />
          </List>
          <List item component="li">
            <CountrySwitcher
              labelRootClass={s.countryLabel}
              selectRootClass={s.countrySelect}
              label={intl.formatMessage({ ...messages.country })}
              value={countryCode}
              basic={false}
              onChange={value => {
                changeCountry(value);
              }}
            />
          </List>
        </List>
      </div>
    </div>
  );
};

CatalogHeader.propTypes = {
  logo: PropTypes.string,
  intl: PropTypes.shape().isRequired,
  countryCode: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
};

CatalogHeader.defaultProps = {
  logo: undefined,
};

const mapState = state => ({
  salesChannelId: state.config.salesChannelId,
  salesChannelGroup: state.config.salesChannel.group,
  basketIsEmpty: state.basket.data.length === 0,
  countryCode: state.intl.countryCode,
  locale: state.intl.locale,
  mode: state.user.mode,
  vouchers: state.basket.vouchers,
});

export default compose(
  withResponsiveWrapper(),
  injectIntl,
  withStyles(s),
  connect(mapState),
)(CatalogHeader);
